import { useEffect, useState } from "react";
import Hero from "../components/Hero";
import EventsSection from "../components/EventsSection";
import GalleryPreview from "../components/GalleryPreview";
import VipTeaser from "../components/VipTeaser";
import MenuPreview from "../components/MenuPreview";
import ReviewsSection from "../components/ReviewsSection";
import BlogHomeStrip from "../components/BlogHomeStrip";
import HomeAbout from "../components/HomeAbout";
import { settings as settingsApi } from "../lib/api";

export default function HomePage() {
  const [siteSettings, setSiteSettings] = useState(null);
  useEffect(() => { settingsApi.get().then(setSiteSettings).catch(() => {}); }, []);

  return (
    <main data-testid="home-page" className="bg-white">
      <Hero settings={siteSettings} />

      {/* Marquee strip */}
      <div className="relative overflow-hidden border-y border-black/5 bg-white py-5">
        <div className="marquee whitespace-nowrap">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex items-center gap-12 text-black/35 font-display text-lg md:text-xl tracking-luxe-tight uppercase">
              <span>Rooftop Nightlife</span><span className="text-gold">✦</span>
              <span>VIP Bottle Service</span><span className="text-gold">✦</span>
              <span>Washington · DC</span><span className="text-gold">✦</span>
              <span>Curated Entertainment</span><span className="text-gold">✦</span>
              <span>Exclusive Reservations</span><span className="text-gold">✦</span>
              <span>Luxury Hospitality</span><span className="text-gold">✦</span>
            </div>
          ))}
        </div>
      </div>

      <EventsSection limit={12} />
      <HomeAbout />
      <VipTeaser />
      <GalleryPreview />
      <MenuPreview />
      <ReviewsSection />
      <BlogHomeStrip />
    </main>
  );
}
